import { render, staticRenderFns } from "./TapDisburstmentRequestStudentEligibility.vue?vue&type=template&id=1ea65e74&"
import script from "./TapDisburstmentRequestStudentEligibility.vue?vue&type=script&lang=js&"
export * from "./TapDisburstmentRequestStudentEligibility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports